import React from 'react';
import styled from 'styled-components';

const FooterContainer = styled.footer`
  background-color: #0a1a1f;
  padding: 3rem 2rem 2rem;
  
  @media (max-width: 768px) {
    padding: 2rem 1.5rem 1.5rem;
  }
  color: white;
  position: relative;
`;

const PartnersSection = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  margin-top: 2rem;
  
  @media (max-width: 768px) {
    margin-top: 1rem;
  }
`;

const Partner = styled.div`
  text-align: center;
  margin: 0 40px 20px;
  
  @media (max-width: 768px) {
    margin: 0 20px 20px;
  }
`;

const PartnerLabel = styled.div`
  font-size: 1rem;
  color: #ccc;
  margin-bottom: 15px;
  letter-spacing: 1px;
  
  @media (max-width: 768px) {
    font-size: 0.9rem;
    margin-bottom: 10px;
  }
`;

const PartnerLogo = styled.div`
  background-color: rgba(255, 255, 255, 0.9);
  padding: 15px;
  border-radius: 12px;
  width: 180px;
  height: 90px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
  transition: transform 0.3s ease;
  
  &:hover {
    transform: scale(1.05);
  }
  
  img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }
  
  @media (max-width: 768px) {
    width: 150px;
    height: 75px;
  }
`;

const DarkPartnerLogo = styled(PartnerLogo)`
  background-color: #1e3a45;
  border: 1px solid #00e1c7;
`;

const CopyrightSection = styled.div`
  text-align: center;
  margin-top: 3rem;
  padding-top: 2rem;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  
  @media (max-width: 768px) {
    margin-top: 2rem;
    padding-top: 1.5rem;
  }
`;

const Copyright = styled.p`
  color: #aaa;
  font-size: 0.9rem;
  margin-bottom: 0.5rem;
`;

const Tagline = styled.p`
  color: #00e1c7;
  font-size: 1rem;
  font-weight: 500;
  letter-spacing: 1px;
  
  @media (max-width: 768px) {
    font-size: 0.9rem;
    padding: 0 1rem;
  }
`;

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <FooterContainer>
      <PartnersSection>
        <Partner>
          <PartnerLabel>Developed by</PartnerLabel>
          <PartnerLogo>
            <img src="/images/empi_logo.png" alt="EMPI Innovation Hub" />
          </PartnerLogo>
        </Partner>
        <Partner>
          <PartnerLabel>Supported by</PartnerLabel>
          <PartnerLogo>
            <img src="/images/iit_roorkee_logo.png" alt="IIT Roorkee" />
          </PartnerLogo>
        </Partner>
        <Partner>
          <PartnerLabel>Technology Partner</PartnerLabel>
          <DarkPartnerLogo>
            <img src="/techpartner3.png" alt="Technology Partner" />
          </DarkPartnerLogo>
        </Partner>
      </PartnersSection>
      
      <CopyrightSection>
        <Copyright>© {currentYear} ParkGanga. All rights reserved.</Copyright>
        <Tagline>Smart Parking Solution</Tagline>
      </CopyrightSection>
    </FooterContainer>
  );
};

export default Footer;